// PHASE 5: How confident are you in your ability to learn this language?
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🚀',
    title: 'pages.onboarding.selfEfficacy.answer1',
    subtitle: 'pages.onboarding.selfEfficacy.answer1Subtitle',
  },
  {
    emoji: '😊',
    title: 'pages.onboarding.selfEfficacy.answer2',
    subtitle: 'pages.onboarding.selfEfficacy.answer2Subtitle',
  },
  {
    emoji: '🤔',
    title: 'pages.onboarding.selfEfficacy.answer3',
    subtitle: 'pages.onboarding.selfEfficacy.answer3Subtitle',
  },
  {
    emoji: '😟',
    title: 'pages.onboarding.selfEfficacy.answer4',
    subtitle: 'pages.onboarding.selfEfficacy.answer4Subtitle',
  },
  {
    emoji: '🌱',
    title: 'pages.onboarding.selfEfficacy.answer5',
    subtitle: 'pages.onboarding.selfEfficacy.answer5Subtitle',
  },
]

export default function SelfEfficacyPage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.selfEfficacy.title"
      subtitle="pages.onboarding.selfEfficacy.subtitle"
    />
  )
}
